import {Loader} from '@mantine/core';
import Image from 'next/image';
import type {FC} from 'react';
import {useGetCompanyInfo} from '../../../../../core/repositories/companiesRepository';
import {FollowCompanyTypeA} from '../../../../../shared/components/FollowCompany/TypeA';
import {buildCompanyFollowGtmContent} from '../../../../../shared/services/buildCompanyFollowGtmContent';

type Props = {
  companyId: number;
  companyName: string;
  companyIndustry: string;
};

export const TopCompanyInfo: FC<Props> = ({
  companyId,
  companyName,
  companyIndustry,
}) => {
  const {data, isLoading} = useGetCompanyInfo({companyId});

  return isLoading ? (
    <div className="w-full bg-white-1 p-16 flex justify-center items-center">
      <Loader color="gray" />
    </div>
  ) : (
    data?.ok && (
      <div className="w-full bg-white-1 flex justify-between items-center p-16">
        <div className="flex items-center mr-8 w-[calc(100%-154px)]">
          {data.value.logoURL && (
            <div className="w-[60px] h-[50px] flex relative items-center justify-center">
              <Image
                src={data.value.logoURL}
                alt={companyName}
                className="object-contain"
                width={60}
                height={50}
              />
            </div>
          )}
          <div className="ml-8">
            <h1 className="text-md font-bold text-black-1">{companyName}</h1>
            <p className="text-sm text-black-2">{companyIndustry}</p>
          </div>
        </div>
        <FollowCompanyTypeA
          companyId={companyId}
          followerCountInital={data.value.followerCount}
          isFollowedInital={data.value.followed}
          dataGtmContent={buildCompanyFollowGtmContent({
            companyId,
            companyName,
            location: 'recruitment-top',
          })}
        />
      </div>
    )
  );
};
